module.exports = __webpack_public_path__ + "img/flag-border.b2d5b50d.svg";